import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Check, Clear } from '@mui/icons-material';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    message: string;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export default function ConfirmDialog({
    open,
    title = 'Megerősítés',
    message,
    confirmText = 'Igen',
    cancelText = 'Nem',
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>

            <DialogActions>
                <Button sx={{ borderRadius: 50 }} variant={'contained'} color='primary' endIcon={<Check />} onClick={onConfirm}>
                    {confirmText}
                </Button>
                <Button sx={{ borderRadius: 50 }} variant={'contained'} color='warning' endIcon={<Clear />} onClick={onCancel}>
                    {cancelText}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
